export default {
  isFranchiseClinic: state => state.isFranchiseClinic,
};
